import { styled } from '@mui/material'

export const ImageContainer = styled('div')`
  flex: 3;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`

export const FormContainer = styled('div')`
  flex: 1;
  padding: 0px 20px;
  /* TODO: inject COLOR from the theme */
  background-color: #f7f7f7;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`
